import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles";
import { classNames } from "../../../utils";
export const CryptoPunksLogo = t0 => {
  const $ = _c(11);
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = classNames(fillVariants({
      fill: "current"
    }), className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M64,0 C99.346224,0 128,28.653776 128,64 C128,99.346224 99.346224,128 64,128 C28.653776,128 0,99.346224 0,64 C0,28.653776 28.653776,7.10542736e-15 64,0 Z M52.1756098,54.097561 L40,54.097561 L40,66.2731707 L44.0585366,66.2731707 L44.0585366,102.8 L64.3512195,102.8 L64.3512195,94.6829268 L80.5853659,94.6829268 L80.5853659,90.6243902 L84.6439024,90.6243902 L84.6439024,86.5658537 L88.702439,86.5658537 L88.702439,62.2146341 L80.5853659,62.2146341 L80.5853659,58.1560976 L76.5268293,58.1560976 L76.5268293,54.097561 L68.4097561,54.097561 L68.4097561,58.1560976 L64.3512195,58.1560976 L64.3512195,62.2146341 L56.2341463,62.2146341 L56.2341463,58.1560976 L52.1756098,58.1560976 L52.1756098,54.097561 Z M80.5286031,26 L51.9201774,26 L51.9201774,30.0585366 L47.8332594,30.0585366 L47.8332594,34.1170732 L43.7463415,34.1170732 L43.7463415,50.3512195 L88.702439,50.3512195 L88.702439,34.1170732 L84.6155211,34.1170732 L84.6155211,30.0585366 L80.5286031,30.0585366 L80.5286031,26 Z" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rest || $[8] !== size || $[9] !== t2) {
    t4 = <svg aria-label="CryptoPunks" className={t2} fill="currentColor" height={size} viewBox="0 0 128 128" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t3}</svg>;
    $[7] = rest;
    $[8] = size;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};